import { CreativeTemplatesEntities } from '../constants';

export const getTextAssetMaxLengthByTab = (tabKey: CreativeTemplatesEntities) => {
  switch (tabKey) {
    case CreativeTemplatesEntities.Headlines:
      return 250;
    case CreativeTemplatesEntities.PostTexts:
      return 2200;
    case CreativeTemplatesEntities.Descriptions:
      return 293;
  }
};
